<template>
        <p v-if="!sentence.isJoiner" class="sentence-font-size tag multiline-text zero-vertical-margin" v-bind:style="{'background-color' : sentence.premadeCategories[0].color, 'color' : sentence.premadeCategories[0].text_color}">{{text}}</p>
        <p v-else class="sentence-font-size height-min-content zero-vertical-margin tag is-light">{{sentence.text}}</p>
</template>
<script>

    import _ from 'lodash'

    export default {
        name: 'SentenceTag',
        components: {},
        props:['sentence', 'text'],
        data() {
            return {
                loading: false,
                saving: false,
            }
        },
        created(){

        },
        mounted(){

        },
        methods: {},
        watch: {}

    }
</script>

<style lang="css" scoped>
    .sentence-font-size{
        font-size: 0.95rem !important;
        font-weight: 300 !important;
    }
    .height-min-content{
        height: min-content;
    }
</style>



// WEBPACK FOOTER //
// src/components/premade-comments/components/SentenceTag.vue